/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAPIError from '../../../hooks/useAPIError';
import { TarjetaService } from '../../../services';
import { useAuthStore } from '../../../store/AuthContext';
import { PriceFormatter } from '../../../utils/PriceFormatter';
import { TarjetasOroConstants } from '../../TarjetasOro/TarjetasOroConstants';
import IconBack from '../../../Icons/IconBack';
import { ErrorCodeConstants } from '../../../utils/ErrorCodeConstants';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  cuotaAltaSelected?: boolean;
  setReload?: (visible: boolean) => void;
}

const ModalidadForm: FC<Props> = (props) => {
  const { visible, setVisible, cuotaAltaSelected, setReload } = props;
  const dataUser = useAuthStore();
  const [isCuotaAlta, setIsCuotaAlta] = useState<boolean>(
    cuotaAltaSelected !== undefined && cuotaAltaSelected,
  );
  const { moneda } = dataUser.user;
  const { t } = useTranslation();
  const { addError, addWarning, addOro, addErrorBack } = useAPIError();
  const [firstCharge, setFirstCharge] = useState(true);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  addOro(true);
  const getTipoCuota = () => {
    TarjetaService.getCuotaTarjetaOro()
      .then((response) => {
        if (response.data.error === true) {
          if (firstCharge) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          addErrorBack(response.data);
        } else {
          setIsCuotaAlta(response.data === TarjetasOroConstants.TIPO_CUOTA_6);
        }
        setFirstCharge(false);
      })
      .catch((er: any) => {
        console.log(er);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  const setCuotaChanged = (isBaja: boolean) => {
    setIsCuotaAlta(isBaja);
  };

  const priceFormatter = (value: any) => {
    const monedaText = moneda === 'euro' ? t('euro') : t('cc');
    return PriceFormatter.formatStringAsPrice(value as string, monedaText);
  };

  const hideModal = (reload: boolean) => {
    setVisible(false);
    document.body.classList.remove('fix');
    if (reload && setReload !== undefined) {
      setReload(true);
    }
    addOro(false);
  };

  const changeModalidad = () => {
    const data = {
      nuevaCuota: !isCuotaAlta
        ? TarjetasOroConstants.TIPO_CUOTA_4_STRING
        : TarjetasOroConstants.TIPO_CUOTA_6_STRING,
    };

    TarjetaService.cambiarCuotaTarjetaOro(data)
      .then((response) => {
        if (response.data.error === true) {
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
        } else {
          const { pojo } = response.data;
          if (pojo) {
            const { message } = pojo;
            const { isChanged } = pojo;
            if (message !== '') addWarning(message);
            else {
              addErrorBack({
                title: [{ key: 'nlr.vaya.algo.no.ha.ido.bien', arguments: [] }],
                userMessage: [
                  { key: 'tarjetas.club.oro.message', arguments: [] },
                ],
                errorCode:
                  ErrorCodeConstants.TARJETAS_ORO_ERROR_GENERICO_EXCEPTION,
              });
            }
            hideModal(isChanged);
          }
        }
      })
      .catch((er: any) => {
        console.log(er);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
      });
  };

  const doChangheCuota = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    changeModalidad();
  };

  useEffect(() => {
    getTipoCuota();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter' && e.keyCode === 13) {
      const element = document.querySelector(
        'section.o-section--large.form-modalidad.bloque-form.tarjetas.visible',
      ) as HTMLElement;
      element.removeEventListener('keydown', saveInfo, false);
      e.preventDefault();
      e.stopPropagation();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      document.getElementById('modalidad-btn').click();
    }
  };
  useEffect(() => {
    if (visible) {
      const element = document.querySelector(
        'section.o-section--large.form-modalidad.bloque-form.tarjetas.visible',
      ) as HTMLElement;
      element.setAttribute('tabindex', '0');
      element.focus();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      element.addEventListener('keydown', saveInfo, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  return (
    <>
      <section
        className={`o-section--large form-modalidad bloque-form tarjetas ${
          visible ? 'visible' : ''
        }`}
      >
        <div className="container">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <a
            className="link-prev"
            onClick={() => {
              hideModal(false);
            }}
          >
            <div className="icon icon-medium">
              <IconBack />
            </div>
            <p className="u-font-normal u-text-brand u-margin-left">
              {t('tarjetas.tarjeta-oro-datos.back')}
            </p>
          </a>

          <form
            id="form-gasto"
            className="form-datos"
            onSubmit={(e) => doChangheCuota(e)}
            noValidate
          >
            <div className="row u-justify-content-center u-margin-bottom">
              <div className="col-12 col-md-6">
                <h2 className="bloque-datos__title u-text-oro">
                  <span className="divider__square brand-gold-color" />
                  <span className="u-margin-right">
                    {t('tarjetas.tarjeta-oro-datos.change-modality')}
                  </span>
                </h2>
                <div className="form-group u-margin-bottom">
                  <div className="form-group u-margin-bottom-large">
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label htmlFor="cuenta" className="control-label">
                      {t('tarjetas.tarjeta-oro-datos.choose-fee')}
                    </label>

                    <div className="tabs-block__selector">
                      <a
                        className={`tabs-block__selector-item ${
                          !isCuotaAlta ? 'active' : ''
                        }`}
                        onClick={() => setCuotaChanged(false)}
                      >
                        {TarjetasOroConstants.CUATRO_POR_CIENTO}
                      </a>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                      <a
                        className={`tabs-block__selector-item ${
                          isCuotaAlta ? 'active' : ''
                        }`}
                        onClick={() => setCuotaChanged(true)}
                      >
                        {TarjetasOroConstants.SEIS_POR_CIENTO}
                      </a>
                    </div>
                    <div
                      className={`tabs-block__cuota ${
                        !isCuotaAlta ? 'active' : ''
                      }`}
                    >
                      {`${priceFormatter(TarjetasOroConstants.CUOTA_BAJA)} ${t(
                        'tarjetas.hazte-oro.cuota-al-mes',
                      )}`}
                    </div>
                    <div
                      className={`tabs-block__cuota ${
                        isCuotaAlta ? 'active' : ''
                      }`}
                    >
                      {`${priceFormatter(TarjetasOroConstants.CUOTA_ALTA)} ${t(
                        'tarjetas.hazte-oro.cuota-al-mes',
                      )}`}
                    </div>
                  </div>

                  <div className="u-text-right">
                    <button
                      id="modalidad-btn"
                      type="submit"
                      className="btn btn-oro"
                    >
                      {t('tarjetas.tarjeta-oro-datos.change')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>{' '}
    </>
  );
};

export default ModalidadForm;
